import { customAlphabet } from 'nanoid';

/**
 * Generate a nanoid with a hex alphabet
 */
export const nanoidHex = customAlphabet('0123456789abcdef', 24);

/**
 * Generate a nanoid with a hex alphabet that is a valid UUIDv4
 */
export function nanoidUUIDv4(): string {
	const generateId = customAlphabet('0123456789abcdef', 32);
	const id = generateId(); // Generate the actual string

	// Insert version (4) and variant (8-b)
	return (
		id.substring(0, 8) +
		'-' +
		id.substring(8, 12) +
		'-' +
		'4' +
		id.substring(13, 16) +
		'-' +
		((parseInt(id[16], 16) & 0x3) | 0x8).toString(16) +
		id.substring(17, 20) +
		'-' +
		id.substring(20)
	);
}
